import React from 'react';
import { connect, } from 'react-redux';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';

import AvailabilityDialog from 'common/components/AvailabilityDialog';
import Button from 'common/components/Button';
import { repositories, } from 'api';
import ProductsItemPrice from './Price';
import ProductsItemOrderPanelActions from './OrderPanelActions';
import { shopCartOperations, } from 'store/ducks/shopCart';
import { Product, } from './types';

type Props = Product & {
    addToShopCart: Function,
    amountInCartShop: number,
    redirectToProductDetails: () => void,
    images: repositories.products.CollectionTypes.ProductsImageType,
};

const AVAILABILITY_RESON_TYPES = Object.freeze({
    OUT_OF_STOCK: 'Nakład chwilowo wyczerpany',
    _default: null,
});

const ProductsItemOrderPanel: React.FC<Props> = ({
    type,
    addToShopCart,
    price,
    name,
    code,
    slug,
    amountInCartShop,
    availability,
    redirectToProductDetails,
    images,
    minQuantity,
    taxAmount,
}) => {
    const outReason = AVAILABILITY_RESON_TYPES[availability.reason ?? '_default'];

    switch (type) {
        case repositories.products.CollectionTypes.PRODUCTS_PRODUCT_ITEM_MAP.BOOK:
            return (
                <>
                    <Box mb={3}
                        width={{ md: '100%', ...(outReason && { lg: 'auto', }) }}
                        textAlign={{ md: 'right', lg: 'left', }}
                        pl={{ lg: outReason ? 0 : '112px', }}>
                        {outReason ?? <ProductsItemPrice price={price} />}
                    </Box>
                    <Box flexDirection={{ md: 'column', lg: 'row', }}
                        alignItems={{ md: 'flex-end', lg: 'center', }}>
                        <Grid item
                            container
                            justify="flex-end">
                            {availability.availableForSale
                                ? (<ProductsItemOrderPanelActions name={name}
                                    images={images}
                                    code={code}
                                    slug={slug}
                                    price={price}
                                    type={type}
                                    taxAmount={taxAmount}
                                    addToShopCart={addToShopCart}
                                    minQuantity={minQuantity} />)
                                : (<AvailabilityDialog code={code} />)}
                        </Grid>
                    </Box>
                    {/* TODO PB Hacked styles, it needs refactoring. */}
                    <Box mt={1} minHeight={40}>
                        {amountInCartShop > 0 && <Box mt={2}
                            width={{ md: '100%', }}
                            color="warning.main"
                            textAlign={{ md: 'right', lg: 'left', }}
                            pl={{ lg: '112px', }}>
                            {amountInCartShop} egz. w koszyku
                    </Box>}
                    </Box>
                </>
            );

        default:
            return (
                <>
                    {outReason}
                    {availability.availableForSale
                        ? (<Button isOrderPanel size="medium" onClick={redirectToProductDetails}>Wybierz ofertę</Button>)
                        : (<Box mt={2}><AvailabilityDialog code={code} /></Box>)}
                </>
            );
    }
};

ProductsItemOrderPanel.defaultProps = {
    amountInCartShop: 0,
};

const mapDispatchToProps = {
    addToShopCart: shopCartOperations.addToShopCart,
};

export default connect(
    null,
    mapDispatchToProps,
)(ProductsItemOrderPanel);
